export interface FilterChangedEvent {
  $event?: any;
  field?: string;
  value?: string | boolean | number | Array<string> | Array<number>;
}
